import _get from "lodash/get";
import { css } from "styled-components";

var _getTheme = function _getTheme(object, propName) {
  return _get(object, propName, _get(object, "theme." + propName));
};

export function get(propName, defaultValue) {
  return function (object) {
    return _getTheme(object, propName, defaultValue);
  };
}

export function getIf(testPropName, propName) {
  return function (object) {
    var testProp = _getTheme(object, testPropName);
    return testProp ? _getTheme(object, propName) : "";
  };
}

export function mixin(propName) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (object) {
    var fn = _getTheme(object, propName);
    if (!fn) throw new Error("undefined prop name " + propName + " for object " + object);
    return fn.apply(undefined, args);
  };
}

export var ROOT_FONT_SIZE_IN_PX = 16;

export function sizeInPxToFontSize(size) {
  return Number(size / ROOT_FONT_SIZE_IN_PX).toFixed(2) + "rem";
}

export function toggle(propName, valueIfTrue) {
  var valueIfFalse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return function (object) {
    var prop = _getTheme(object, propName);
    return prop ? css(["", ";"], valueIfTrue) : css(["", ";"], valueIfFalse);
  };
}

export function unit(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "px";

  if (typeof value === "string") return value;
  return "" + value + unit;
}

export function reset() {
  return css(["background:transparent none;border:0;list-style:none;margin:0;padding:0;"]);
}

export function hide() {
  return css(["font-size:0;height:0;overflow:hidden;position:absolute;visibility:hidden;width:0;"]);
}

export function responsiveImg() {
  var onHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return onHeight ? css(["max-height:100%;width:auto;"]) : css(["height:auto;max-width:100%;"]);
}

export function truncate(width) {
  return "\n    " + (!!width && css(["width:", ";"], unit(width))) + ";\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ";
}

export function minHeight(height) {
  return function () {
    return css(["@media (min-height:", "){", ";}"], unit(height), css.apply(undefined, arguments));
  };
}

export function bigPhone() {
  return minHeight(700).apply(undefined, arguments);
}
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/style/util.js
// module id = 5
// module chunks = 0